"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VdqsClient = void 0;
class VdqsClient {
    constructor(authService, stage) {
        this.authService = authService;
        this.stage = stage;
        this.resourceHostId = `myvw-vdqs-${this.stage}`;
    }
    async getUserIdent() {
        try {
            const response = await this.authService.get(this.resourceHostId, `v1/userIdent`);
            if (!response.ok) {
                throw new Error(`VDQS API call failed with status: ${response.status}`);
            }
            return await response.json();
        }
        catch (error) {
            if (error instanceof Error) {
                throw new Error(`VDQS API call failed: ${error.message}`);
            }
            throw new Error('something went wrong');
        }
    }
}
exports.VdqsClient = VdqsClient;
//# sourceMappingURL=VdqsClient.js.map